<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string
    items?: {
      title: string
      description?: string
    }[]
  }>(),
  {
    title:
      'Integrasi Cepat & Mudah, Plugin Ongkir & Cek Resi WooCommerce Langsung Aktif',
    items: () => [
      {
        title: 'Install Plugin WooCommerce KiriminAja',
        description: 'Unduh plugin langsung dari dashboard KiriminAja.'
      },
      {
        title: 'Hubungkan Akun KiriminAja',
        description:
          'Masukkan API Key KiriminAja dan aktifkan ekspedisi AnterAja.'
      },
      {
        title: 'Tarif Otomatis di Checkout',
        description:
          'Ongkos kirim otomatis muncul lengkap dengan estimasi waktu kirim.'
      },
      {
        title: 'Buat & Kirim Resi Instan',
        description:
          'Setelah order dikonfirmasi, nomor resi otomatis dikirim ke pelanggan.'
      },
      {
        title: 'Pantau Pengiriman Real-Time',
        description:
          'Semua status pengiriman dapat Anda pantau langsung dari dashboard WooCommerce.'
      }
    ]
  }
)
</script>

<template>
  <div
    class="bg-surface-container-low dark:bg-surface-container-highest py-6 lg:py-16 relative overflow-hidden"
  >
    <UiBgSkewY />
    <UiContainer class="flex flex-col gap-6 lg:gap-11 relative z-10">
      <UiSectionTitle
        class="text-center"
        :title="title"
        description="Ikuti langkah-langkah berikut untuk menginstall dan mengatur plugin KiriminAja di toko online WooCommerce kamu."
      />
      <div class="grid lg:grid-cols-6 gap-5">
        <div class="lg:col-span-2 space-y-3">
          <UiCardFeature
            v-for="(item, key) in items"
            :key="key"
            :icon="`material-symbols:counter-${key + 1}-outline`"
            icon-size="24px"
            :title="item.title"
            wrapper-class="flex-row"
            title-class="lg:text-base"
            :description="item.description"
            description-class="text-sm"
          />
        </div>

        <div class="lg:col-span-4">
          <UiPlayerYoutube video-id="frQsHwIVTIw" />
        </div>
      </div>
    </UiContainer>
  </div>
</template>
